import type { Category, FAQ } from './types';

export const categories: Category[] = [
  {
    slug: 'hot',
    name: '热门推荐',
    icon: 'ri-fire-line',
    description: '全网最热视频内容精选，每日更新热门视频推荐',
  },
  {
    slug: 'new',
    name: '最新上线',
    icon: 'ri-flashlight-line',
    description: '第一时间获取最新上线的精彩视频内容',
  },
  {
    slug: 'movie',
    name: '电影',
    icon: 'ri-film-line',
    description: '精选高清电影大片，涵盖动作、喜剧、爱情等多种类型',
  },
  {
    slug: 'drama',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门电视剧全集在线观看，国产剧、韩剧、美剧一网打尽',
  },
  {
    slug: 'variety',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '最新综艺节目，搞笑、竞演、真人秀等精彩内容',
  },
  {
    slug: 'anime',
    name: '动漫',
    icon: 'ri-rocket-line',
    description: '热门动漫番剧，日漫、国漫精品内容随时畅享',
  },
  {
    slug: 'documentary',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '精品纪录片，探索自然、历史、科技与人文世界',
  },
  {
    slug: 'short',
    name: '短视频',
    icon: 'ri-smartphone-line',
    description: '精彩短视频合集，轻松有趣的碎片化视频内容',
  },
];

export const faqs: FAQ[] = [
  {
    question: '蜜桃视频在线是否需要注册才能观看？',
    answer: '不需要注册。蜜桃视频在线完全免费开放，所有视频内容均可直接在线观看，无需注册账号或登录。',
  },
  {
    question: '观看视频需要下载播放器吗？',
    answer: '完全不需要。蜜桃视频在线采用HTML5流媒体播放技术，支持所有主流浏览器直接播放，无需安装任何插件或播放器。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '蜜桃视频在线支持电脑、平板、手机等多种设备访问。网站采用响应式设计，自动适配不同屏幕尺寸，让您随时随地畅享高清视频。',
  },
  {
    question: '视频画质如何？是否支持高清播放？',
    answer: '蜜桃视频在线提供高清画质播放体验，大部分内容支持1080P高清播放。系统会根据您的网络状况自动调整清晰度，确保流畅观看。',
  },
  {
    question: '如何找到想看的视频内容？',
    answer: '您可以通过首页的搜索功能、分类导航或热门推荐找到感兴趣的视频内容。网站支持按类别浏览，帮助您快速发现精彩视频。',
  },
  {
    question: '观看视频会产生费用吗？',
    answer: '蜜桃视频在线承诺永久免费。所有视频内容均免费提供在线观看，不会产生任何费用。',
  },
];